import { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { FallbackView } from '../../_metronic/partials';
/* v2 - rotas exclusao e manutencao */
import { useAuth } from '../contexts/AuthProvider';
import AndamentoContas from '../pages/andamentoContas';
import Clientes from '../pages/clientes/Clientes';
import ConciliacaoInteligente from '../pages/conciliacao-inteligente';
import ConciliacaoBancaria from '../pages/conciliacao-bancaria';
import ConciliacaoInteligenteEmMassa from '../pages/conciliacao-inteligente-grupo';
import Empresas from '../pages/empresas/Empresas';
import Evento from '../pages/eventos/Evento';
import Importar from '../pages/importar/Importar';
import Dashboard from '../pages/dashboard';
import Auditoria from '../pages/auditoria';
import AuditoriaEntradaDados from '../pages/auditoria/entrada-dados';
import AuditoriaCircularizacao from '../pages/auditoria/circularizacao';
import AuditoriaCircularizacaoCategoria from '../pages/auditoria/circularizacao/CategoriaCircularizacaoPage';
import AuditoriaRevisao from '../pages/auditoria/AuditoriaRevisaoPage';
import ImportarNovo from '../pages/importar/ImportarNovo';
import ImportarRazao from '../pages/importar-razao/ImportarRazao';
import Relatorio from '../pages/relatorios/Relatorio';
import RelatorioAviso from '../pages/relatorios/RelatorioAviso';
import RelatorioConciliado from '../pages/relatorios/RelatorioConciliado';
import RelatorioErro from '../pages/relatorios/RelatorioErro';
import RelatorioMatch from '../pages/relatorios/RelatorioMatch';
import RelatorioPendentes from '../pages/relatorios/RelatorioPendentes';
import RelatorioRecomendacao from '../pages/relatorios/RelatorioRecomendacao';
import RelatorioSelecionarCliente from '../pages/relatorios/RelatorioSelecionarCliente';
import Usuarios from '../pages/usuarios/Usuarios';
import Suporte from '../pages/suporte';
import UsuariosAdmin from '../pages/usuariosAdmin/Usuarios';
import AprovacaoAlteracao from '../pages/aprovacaoAlteracao/aprovacaoAlteracao';
import SuporteInterno from '../pages/suporteInterno';
import AndamentoContasResultado from '../pages/andamentoContasResultado';
import MapaResultado from '../pages/mapaResultado';
import NovoAndamentoContas from '../pages/novoAndamentoContas';
import ConsultaLancamentos from '../pages/consultaLancamentos';
import ModuloBancario from '../pages/modulo-bancario';
import Integracao from '../pages/integracao/integracao/integracao';
import RegrasParametrizadas from '../pages/regras-parametrizadas';
import FormRegra from '../pages/regras-parametrizadas/form-regra';
import CapaConciliacao from '../pages/capa-conciliacao';
import IrrfFolhaConciliacao from '../pages/irrf-folha-conciliacao';
import RazaoLayouts from '../pages/razao-layouts';
import FormRazaoLayout from '../pages/razao-layouts/form-razao-layout';
import SaldoInicialLoteDetalhe from '../pages/saldoInicialLote/detalhe';
import FolhaPagamentoGlobalDetalhe from '../pages/folhaPagamentoGlobal/detalhe';
import GerenciarSaldoInicial from '../pages/gerenciarSaldoInicial';
import {WorkflowRoutes} from '../pages/workflow-aprovacao'
import {MaestroRoutes} from '../pages/maestro-contabil'
import { isUsuarioInterno } from '../utils/UsuarioInterno';
import ApiKeys from '../pages/apiKeys/ApiKeys';

export function PrivateRoutes() {
  const { usuario } = useAuth();
  // Importar Razão Universal só para usuários @ainumera.com (DEVN3-600) — demais caem no 404.
  const usuarioInterno = isUsuarioInterno(usuario?.email);

  return (
    <Suspense fallback={<FallbackView />}>
      {usuario?.perfil === 'Analista' &&
        <Switch>
          <Route exact path='/empresas' component={Empresas} />
          <Route exact path='/importar' component={Importar} />
          <Route exact path='/integracao' component={Integracao} />
          <Route exact path='/modulo-bancario' component={ModuloBancario} />
          <Route exact path='/importar/novo' component={ImportarNovo} />
          {usuarioInterno && <Route exact path='/importar-razao' component={ImportarRazao} />}
          <Route exact path='/relatorioSelecionarCliente' component={RelatorioSelecionarCliente} />
          <Route exact path='/relatorio/:id' component={Relatorio} />
          <Route exact path='/Relatorio/:id/Erro' component={RelatorioErro} />
          <Route exact path='/Relatorio/:id/Aviso' component={RelatorioAviso} />
          <Route exact path='/Relatorio/:id/Recomendacao' component={RelatorioRecomendacao} />
          <Route exact path='/Relatorio/:id/Match' component={RelatorioMatch} />
          <Route exact path='/Relatorio/:id/Pendente' component={RelatorioPendentes} />
          <Route exact path='/Relatorio/:id/Conciliado' component={RelatorioConciliado} />
          <Route exact path='/andamento-contas' component={AndamentoContas} />
          <Route exact path='/novo-andamento-contas' component={NovoAndamentoContas} />
          <Route exact path='/consulta-lancamentos' component={ConsultaLancamentos} />
          <Route exact path='/andamento-contas-resultado' component={AndamentoContasResultado} />
          <Route exact path='/mapa-resultado' component={MapaResultado} />
          <Route exact path='/saldo-inicial-lote/:esteiraId/:arquivoOperacaoId' component={SaldoInicialLoteDetalhe} />
          <Route exact path='/folha-pagamento-global/:esteiraId/:arquivoOperacaoId' component={FolhaPagamentoGlobalDetalhe} />
          <Route exact path='/gerenciar-saldo-inicial' component={GerenciarSaldoInicial} />
          <Route exact path='/dashboard' component={Dashboard} />
          <Route exact path='/auditoria' component={Auditoria} />
          <Route exact path='/auditoria/entrada-dados' component={AuditoriaEntradaDados} />
          <Route exact path='/auditoria/circularizacao' component={AuditoriaCircularizacao} />
          <Route exact path='/auditoria/circularizacao/:categoria' component={AuditoriaCircularizacaoCategoria} />
          <Route exact path='/auditoria/revisao' component={AuditoriaRevisao} />
          <Route path='/workflow-aprovacao' component={WorkflowRoutes} />
          <Route path='/maestro-contabil' component={MaestroRoutes} />
          {!usuario?.controlaClientes ? <Route exact path='/suporte' component={Suporte} /> : <Route exact path='/suporte-interno' component={SuporteInterno} />}
          <Route exact path='/aprovacao-alteracao' component={AprovacaoAlteracao} />
          <Route exact path='/andamento-contas/:empresaParam/:esteiraParam' component={AndamentoContas} />
          <Route exact path='/conciliacao/:esteiraParam/:cartaoParam' component={ConciliacaoInteligente} />
          <Route exact path='/conciliacao-grupo/:empresaParam/:esteiraParam/:contaParam' component={ConciliacaoInteligenteEmMassa} />
          <Route exact path='/conciliacao-bancaria/:esteiraParam/:cartaoParam' component={ConciliacaoBancaria} />
          <Route exact path='/capa-conciliacao/:idCartao' component={CapaConciliacao} />
          <Route exact path='/irrf-folha-conciliacao/:esteiraParam' component={IrrfFolhaConciliacao} />
          <Redirect from='/login' to='/relatorioSelecionarCliente' />
          <Redirect exact from='/' to='/relatorioSelecionarCliente' />
          <Redirect to='error/404' />
        </Switch>
      }

      {usuario?.perfil === 'Administrador' &&
        <Switch>
          <Route exact path='/usuarios' component={UsuariosAdmin} />
          {/* DEVN3-627: API Keys só para Administrador e Master — Analista cai no 404. Ainda não
              liberado aos clientes: só usuários @ainumera.com; os demais também caem no 404. */}
          {usuarioInterno && <Route exact path='/api-keys' component={ApiKeys} />}
          <Route exact path='/empresas' component={Empresas} />
          <Route exact path='/importar' component={Importar} />
          <Route exact path='/integracao' component={Integracao} />
          <Route exact path='/modulo-bancario' component={ModuloBancario} />
          <Route exact path='/importar/novo' component={ImportarNovo} />
          {usuarioInterno && <Route exact path='/importar-razao' component={ImportarRazao} />}
          <Route exact path='/relatorioSelecionarCliente' component={RelatorioSelecionarCliente} />
          <Route exact path='/relatorio/:id' component={Relatorio} />
          <Route exact path='/Relatorio/:id/Erro' component={RelatorioErro} />
          {!usuario?.controlaClientes ? <Route exact path='/suporte' component={Suporte} /> : <Route exact path='/suporte-interno' component={SuporteInterno} />}
          <Route exact path='/Relatorio/:id/Aviso' component={RelatorioAviso} />
          <Route exact path='/Relatorio/:id/Recomendacao' component={RelatorioRecomendacao} />
          <Route exact path='/Relatorio/:id/Match' component={RelatorioMatch} />
          <Route exact path='/Relatorio/:id/Pendente' component={RelatorioPendentes} />
          <Route exact path='/Relatorio/:id/Conciliado' component={RelatorioConciliado} />
          <Route exact path='/dashboard' component={Dashboard} />
          <Route exact path='/auditoria' component={Auditoria} />
          <Route exact path='/auditoria/entrada-dados' component={AuditoriaEntradaDados} />
          <Route exact path='/auditoria/circularizacao' component={AuditoriaCircularizacao} />
          <Route exact path='/auditoria/circularizacao/:categoria' component={AuditoriaCircularizacaoCategoria} />
          <Route exact path='/auditoria/revisao' component={AuditoriaRevisao} />
          <Route path='/workflow-aprovacao' component={WorkflowRoutes} />
          <Route path='/maestro-contabil' component={MaestroRoutes} />
          <Route exact path='/aprovacao-alteracao' component={AprovacaoAlteracao} />
          <Route exact path='/andamento-contas' component={AndamentoContas} />
          <Route exact path='/novo-andamento-contas' component={NovoAndamentoContas} />
          <Route exact path='/consulta-lancamentos' component={ConsultaLancamentos} />
          <Route exact path='/andamento-contas-resultado' component={AndamentoContasResultado} />
          <Route exact path='/mapa-resultado' component={MapaResultado} />
          <Route exact path='/saldo-inicial-lote/:esteiraId/:arquivoOperacaoId' component={SaldoInicialLoteDetalhe} />
          <Route exact path='/folha-pagamento-global/:esteiraId/:arquivoOperacaoId' component={FolhaPagamentoGlobalDetalhe} />
          <Route exact path='/gerenciar-saldo-inicial' component={GerenciarSaldoInicial} />
          <Route exact path='/andamento-contas/:empresaParam/:esteiraParam' component={AndamentoContas} />
          <Route exact path='/conciliacao/:esteiraParam/:cartaoParam' component={ConciliacaoInteligente} />
          <Route exact path='/conciliacao-grupo/:empresaParam/:esteiraParam/:contaParam' component={ConciliacaoInteligenteEmMassa} />
          <Route exact path='/conciliacao-bancaria/:esteiraParam/:cartaoParam' component={ConciliacaoBancaria} />
          <Route exact path='/capa-conciliacao/:idCartao' component={CapaConciliacao} />
          <Route exact path='/irrf-folha-conciliacao/:esteiraParam' component={IrrfFolhaConciliacao} />
          <Redirect from='/login' to='/relatorioSelecionarCliente' />
          <Redirect exact from='/' to='/relatorioSelecionarCliente' />
          <Redirect to='error/404' />
        </Switch>
      }

      {usuario?.perfil === 'Master' &&
        <Switch>
          <Route exact path='/clientes' component={Clientes} />
          <Route exact path='/eventos' component={Evento} />
          <Route exact path='/suporte-interno' component={SuporteInterno} />
          <Route exact path='/usuarios' component={Usuarios} />
          {usuarioInterno && <Route exact path='/api-keys' component={ApiKeys} />}
          <Route exact path='/Relatorio/:id/Conciliado' component={RelatorioConciliado} />
          <Route exact path='/andamento-contas' component={AndamentoContas} />
          <Route exact path='/novo-andamento-contas' component={NovoAndamentoContas} />
          <Route exact path='/consulta-lancamentos' component={ConsultaLancamentos} />
          <Route exact path='/parametrizacoes/regra/conciliacao' component={RegrasParametrizadas} />
          <Route exact path='/parametrizacoes/regra/conciliacao/formulario' component={FormRegra} />
          <Route exact path='/parametrizacoes/regra/conciliacao/formulario/:id' component={FormRegra} />
          <Route exact path='/parametrizacoes/razao/layouts' component={RazaoLayouts} />
          <Route exact path='/parametrizacoes/razao/layouts/novo' component={FormRazaoLayout} />
          <Route exact path='/parametrizacoes/razao/layouts/:id' component={FormRazaoLayout} />
          <Route exact path='/andamento-contas/:empresaParam/:esteiraParam' component={AndamentoContas} />
          <Route exact path='/conciliacao/:empresaParam/:esteiraParam/:contaParam' component={ConciliacaoInteligente} />
          <Route exact path='/conciliacao-grupo/:empresaParam/:esteiraParam/:contaParam' component={ConciliacaoInteligenteEmMassa} />
          <Route exact path='/conciliacao-bancaria/:esteiraParam/:cartaoParam' component={ConciliacaoBancaria} />
          <Route exact path='/capa-conciliacao/:idCartao' component={CapaConciliacao} />
          <Route exact path='/irrf-folha-conciliacao/:esteiraParam' component={IrrfFolhaConciliacao} />
          <Redirect from='/login' to='/clientes' />
          <Redirect exact from='/' to='/clientes' />
          <Redirect to='error/404' />
        </Switch>
      }
    </Suspense >
  )
}